import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { uniq } from 'lodash';

interface FollowState {
  followedIds: string[];
}

const initialState: FollowState = {
  followedIds: []
};

const followSlice = createSlice({
  name: 'follow',
  initialState,
  reducers: {
    addFollowId(state, action: PayloadAction<string>) {
      if (!state.followedIds.includes(action.payload)) {
        state.followedIds = uniq([...state.followedIds, action.payload]);
      }
    },
    removeFollowId(state, action: PayloadAction<string>) {
      state.followedIds = state.followedIds.filter((id) => id !== action.payload);
    },
    setFollowedIds(state, action: PayloadAction<string[]>) {
      state.followedIds = uniq(action.payload);
    },
    resetFollowedIds(state) {
      state.followedIds = [];
    }
  }
});

export const {
  addFollowId,
  removeFollowId,
  setFollowedIds,
  resetFollowedIds
} = followSlice.actions;

export default followSlice.reducer;